<template>
  <div class="editorial-collection-carousel">
    <div class="container container--flush">
      <div class="editorial-collection-carousel__header">
        <h2 class="editorial-collection-carousel__title">{{ title }}</h2>
        <p class="editorial-collection-carousel__text">{{ text }}</p>
      </div>
      <div class="editorial-collection-carousel__carousel">
        <Carousel no-controls inline width="250px" width-desktop="300px">
          <div v-for="product in products" :key="product.id" class="slide">
            <ProductCardHelper
              v-slot="{ primaryMedia, secondaryMedia }"
              :product="product"
              :image-type="imageType"
            >
              <ProductCard
                :product="product"
                :media="primaryMedia"
                :hover-media="secondaryMedia"
              />
            </ProductCardHelper>
          </div>
        </Carousel>
        <div class="editorial-collection-carousel__button">
          <Button tag="a" :href="collection.onlineStoreUrl" width="full">
            Explore the Collection
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from "@/components/Carousel.vue";
import Button from "@/components/ButtonV2.vue";
import collectionQuery from "@/graphql/queries/CollectionV2.gql";
import ProductCardHelper from "@/components/product-card/ProductCardHelper.vue";
import ProductCard from "@/components/ProductCard.vue";
import { unwrapNodes } from "@/helpers/graphql";
import { RelayConnection } from "@/helpers/pagination";

export default {
  name: "EditorialCollectionCarousel",
  components: {
    ProductCardHelper,
    ProductCard,
    Carousel,
    Button,
  },
  props: {
    collectionHandle: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    imageType: {
      type: String,
      default: "campaignImages",
    },
  },
  data() {
    return {
      collection: {
        products: new RelayConnection(),
      },
    };
  },
  computed: {
    products() {
      return unwrapNodes(this.collection?.products?.edges);
    },
  },
  apollo: {
    collection: {
      query: collectionQuery,
      skip() {
        return !this.collectionHandle;
      },
      variables() {
        return {
          collection: this.collectionHandle,
          first: 250,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.editorial-collection-carousel {
  padding: 40px 0 60px;

  @include respond-above(md) {
    padding: 60px 0;
  }

  .container {
    @include respond-above(md) {
      display: flex;
      gap: 100px;
    }
  }

  &__header {
    margin-bottom: 40px;
    @extend .containerV2;

    @include respond-above(md) {
      box-sizing: content-box;
      padding: 0 0 0 $v-container-padding--desktop + 0px;
      margin-bottom: 40px;
      width: 250px;
      flex: 0 0 auto;
    }
  }

  &__carousel {
    @include respond-above(md) {
      flex: 1 0 auto;
    }
  }

  &__title {
    margin-bottom: 20px;
    @include editorial-headline(20px);
    @include respond-above(md) {
      @include editorial-headline(28px);
      margin-bottom: 16px;
    }
  }

  &__text {
    display: block;
    @include editorial-body(14px);
  }

  &__button {
    @extend .containerV2;
    display: block;
    text-align: center;
    margin-top: 40px;

    @include respond-above(md) {
      display: none;
    }
  }
}
</style>
